import { isEmpty } from 'lodash';
import { ActionButton } from '../../components/vertical-dot/popper';
import { TableBodyCellColumn, TableBodyCellColumnCenter } from '../style/table.styled';
import moment from 'moment';
import { DATE_FORMAT } from '../common';

export const SwitchToProductionHeader = ({ actions }: { actions: any }): any[] => {
  return actions || [];
  return [
    {
      Header: 'Sandbox Tenant Name',
      accessor: 'sandboxTenantName',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className=''>
            <div className='cellTitle'>
              {!isEmpty(row.original.sandboxTenantName) ? row.original.sandboxTenantName : '-'}
            </div>
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Production Tenant Name',
      accessor: 'productionTenantName',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className=''>
            <div className='cellTitle '>
              {!isEmpty(row.original.productionTenantName)
                ? row.original.productionTenantName
                : '-'}
            </div>
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Username',
      accessor: 'userName',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className=''>
            <div className='cellTitle '>
              {!isEmpty(row.original.userName) ? row.original.userName : '-'}
            </div>
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Created At',
      accessor: 'creationTime',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn>
            {!isEmpty(row.original.creationTime)
              ? moment(row.original.creationTime).format(DATE_FORMAT)
              : '-'}
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Remarks',
      accessor: 'remarks',
      width: 200,
      sortable: true,
      center: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className='text-left'>
            <div className=''>{!isEmpty(row.original.remarks) ? row.original.remarks : '-'}</div>
          </TableBodyCellColumn>
        );
      },
    },
    // {
    //   Header: '',
    //   accessor: 'actions',
    //   width: 80,
    //   sortable: false,
    //   Cell: ({ row }: any) => {
    //     return (
    //       <div>
    //         {
    //           <ActionButton
    //             actions={action}
    //             id={row.original.tenantId}
    //             rowData={row.original}
    //             counter={parseInt(row?.tenantId)}
    //           />
    //         }
    //       </div>
    //     );
    //   },
    // },
  ];
};
